<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title1]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc1]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title2]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc2]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title3]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc3]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title4]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc4]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title5]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc5]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title6]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc6]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title7]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc7]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title8]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc8]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title9]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc9]"></ng-content>
  </div>
</div>

<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title10]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc10]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title11]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc11]"></ng-content>
  </div>
</div>
<div class="d-flex flex-wrap mt-3">
  <div class="q-tab-content-title">
    <ng-content select="[title12]"></ng-content>
  </div>
  <div class="q-tab-content-desc">
    <ng-content select="[desc12]"></ng-content>
  </div>
</div>
<div>
  <ng-content select="[title9]"></ng-content>
</div>
<div class="d-flex mt-4 mb-2">
  <div class="q-tab-content-title">
    <ng-content select="[btn1]"></ng-content>
  </div>
  <div>
    <ng-content select="[btn2]"></ng-content>
  </div>
  <div>
    <ng-content select="[btn3]"></ng-content>
  </div>
  <div>
    <ng-content select="[btn4]"></ng-content>
  </div>
  <div>
    <ng-content select="[btn5]"></ng-content>
  </div>
</div>